<template>
    <svg viewBox="0 0 43 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_16605_236797)">
            <path
                d="M2.93182 31.9998H9.77273V15.5149L0 8.24219V29.0907C0 30.7004 1.31443 31.9998 2.93182 31.9998Z"
                fill="#4285F4"
            />
            <path
                d="M33.2266 31.9998H40.0675C41.6897 31.9998 42.9993 30.6955 42.9993 29.0907V8.24219L33.2266 15.5149"
                fill="#34A853"
            />
            <path
                d="M33.2266 2.90904V15.5151L42.9993 8.24238V4.36359C42.9993 0.766012 38.8605 -1.2849 35.9629 0.872679"
                fill="#FBBC04"
            />
            <path
                d="M9.77344 15.5152V2.90918L21.5007 11.6365L33.228 2.90918V15.5152L21.5007 24.2425"
                fill="#EA4335"
            />
            <path
                d="M0 4.36359V8.24238L9.77273 15.5151V2.90904L7.03636 0.872679C4.13386 -1.2849 0 0.766012 0 4.36359Z"
                fill="#C5221F"
            />
        </g>
        <defs>
            <clipPath id="clip0_16605_236797">
                <rect width="43" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
